import { merge } from 'lodash';

import { Injectable } from '@angular/core';

import { ISnInputFormFieldConfig } from '@lib/form/input';
import { t } from '@lib/translation';

@Injectable({ providedIn: 'root' })
export class SnLprFieldsGeneratorService {
  constructor() {}

  public addPlateField(fieldConfig?: Partial<ISnInputFormFieldConfig>): ISnInputFormFieldConfig {
    const baseFieldConfig: ISnInputFormFieldConfig = {
      key: 'plate',
      type: 'input',
      templateOptions: {
        label: t('vehicleIntelligence.hotlist.plate'),
        placeholder: t('vehicleIntelligence.hotlist.enterPlate'),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }
}
